import {
  ACCESS_LEVELS,
} from '@/lib/consts.ts'
import { ROUTE_META_PARAMS } from '@/router/consts.ts'
import { __t } from '@/lib/helpers'

import { ACCESS_LEVEL_PERMISSION } from '@/composables/access-level-permissions/const'
import { verifactuCustomInvoiceIssuanceBeforeEnter } from '@/composables/verifactu/use-custom-invoice-gate.ts'

export const shouldBeVisible = (store) => {
  const isFrenchCertificationEnabled = store.getters['business/isFrenchCertificationEnabled']
  return !isFrenchCertificationEnabled
}

const shouldBeVisibleForFrCert = (store) => {
  const isFrenchCertificationEnabled = store.getters['business/isFrenchCertificationEnabled']
  return isFrenchCertificationEnabled
}

export default {
  path: 'sales',
  name: 'sales',
  meta: {
    [ROUTE_META_PARAMS.ACCESS_LEVEL_PERMISSION]: ACCESS_LEVEL_PERMISSION.checkout,
    defaultSubroute: {
      name: 'checkout',
    },
    hintKey: 'hintFeatureCheckout',
  },
  component: () => import('@/views/business/sales/index.vue'),
  children: [
    {
      path: 'checkout',
      name: 'checkout',
      component: () => import('@/views/business/sales/checkout/index.vue'),
      meta: {
        useSmartlook: true,
      },
    },
    {
      path: 'transactions',
      name: 'sales.transactions',
      meta: {
        title: __t('components.payments.transactions.title'),
        subtitle: __t('components.payments.transactions.subtitle'),
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.ADVANCED,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisible,
      },
      // FLS-1382: hot fix until handling transactions list in both Sales and Settings/Payments is available
      redirect: {
        name: 'settings.payments.transactions.list',
        query: {
          mode: 'sales',
        },
      },
    },
    {
      path: 'cash-registers',
      name: 'sales.cash-registers',
      meta: {
        [ROUTE_META_PARAMS.ACCESS_LEVEL_PERMISSION]: ACCESS_LEVEL_PERMISSION.checkout,

        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: (store) => {
          const { business } = store.state
          return business.pos.registers_enabled
        },
      },
      component: () => import('@/views/business/sales/cash-registers/index.vue'),
    },
    {
      path: 'invoices',
      name: 'sales.invoices',
      meta: {
        defaultSubroute: {
          name: 'sales.invoices.list',
        },
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.ADVANCED,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisible,
      },
      component: () => import('@/views/business/sales/invoices/index.vue'),
      children: [
        {
          path: 'new',
          name: 'sales.invoices.new',
          beforeEnter: verifactuCustomInvoiceIssuanceBeforeEnter,
          component: () => import('@/views/business/sales/invoices/form.vue'),
        },
        {
          // creating a invoice correction
          path: ':invoiceIdToCorrect/correction',
          name: 'sales.invoices.correction',
          beforeEnter: verifactuCustomInvoiceIssuanceBeforeEnter,
          component: () => import('@/views/business/sales/invoices/form.vue'),
        },
        {
          path: ':invoiceId/edit',
          name: 'sales.invoices.edit',
          component: () => import('@/views/business/sales/invoices/form.vue'),
        },
        {
          path: ':invoiceId',
          name: 'sales.invoices.details',
          component: () => import('@/views/business/sales/invoices/list.vue'),
        },
        {
          path: '',
          name: 'sales.invoices.list',
          meta: {
            [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisible,
          },
          component: () => import('@/views/business/sales/invoices/list.vue'),
        },
      ],
    },
    {
      path: 'fiscal-receipts',
      name: 'sales.fiscal-receipts',
      meta: {
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.ADVANCED,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisibleForFrCert,
        defaultSubroute: {
          name: 'sales.fiscal-receipts.list',
        },
      },
      component: () => import('@/views/business/sales/fiscal-receipts/index.vue'),
      children: [
        {
          path: ':fiscalReceiptId',
          name: 'sales.fiscal-receipts.details',
          component: () => import('@/views/business/sales/fiscal-receipts/list.vue'),
        },
        {
          path: '',
          name: 'sales.fiscal-receipts.list',
          meta: {
            [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisibleForFrCert,
          },
          component: () => import('@/views/business/sales/fiscal-receipts/list.vue'),
        },
      ],
    },
    {
      path: 'fiscal-archives',
      name: 'sales.fiscal-archives',
      meta: {
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.ADVANCED,
        [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisibleForFrCert,
        defaultSubroute: {
          name: 'sales.fiscal-archives.list',
        },
      },
      component: () => import('@/views/business/sales/fiscal-archives/list.vue'),
      children: [
        {
          path: '',
          name: 'sales.fiscal-archives.list',
          meta: {
            [ROUTE_META_PARAMS.SHOULD_BE_VISIBLE]: shouldBeVisibleForFrCert,
          },
          component: () => import('@/views/business/sales/fiscal-archives/list.vue'),
        },
      ],
    },
  ],
}
